export const MORE_BUTTON_FALLBACK_WIDTH = 96;

export const countFitting = ({ widths, availableWidth, gap = 0, reserve = () => 0 }) => {
  let used = 0;
  let count = 0;
  for (const width of widths) {
    const next = used + (count ? gap : 0) + width;
    if (next + reserve(count + 1) > availableWidth) break;
    used = next;
    count += 1;
  }
  return count;
};

export const splitItemsToFit = ({
  items,
  itemWidths,
  availableWidth,
  gap = 0,
  chromeWidth = 0,
  moreWidth = MORE_BUTTON_FALLBACK_WIDTH,
  activeValue
}) => {
  const allVisible = { visibleItems: items, hiddenItems: [] };

  const isMeasured =
    availableWidth > 0 &&
    itemWidths.length === items.length &&
    itemWidths.every((width) => width > 0);

  if (!items.length || !isMeasured) return allVisible;

  const fitCount = (budget) =>
    countFitting({ widths: itemWidths, availableWidth: budget - chromeWidth, gap });

  if (fitCount(availableWidth) === items.length) return allVisible;

  const budget = availableWidth - moreWidth - gap;
  const activeIndex = items.findIndex((item) => item.value === activeValue);

  let leadingCount = fitCount(budget);
  const isActivePinned = activeIndex > -1 && activeIndex >= leadingCount;

  // Reserve the pinned item's width before filling the prefix, or a wide active item
  // would push the row past the edge.
  if (isActivePinned) leadingCount = fitCount(budget - itemWidths[activeIndex] - gap);
  else leadingCount = Math.max(leadingCount, 1);

  const leadingItems = items.slice(0, leadingCount);

  return {
    visibleItems: isActivePinned ? [...leadingItems, items[activeIndex]] : leadingItems,
    hiddenItems: items.filter(
      (_, index) => index >= leadingCount && !(isActivePinned && index === activeIndex)
    )
  };
};
